export const SUPERADMIN_EMAILS = ['sanghviharmesh06@gmail.com', 'w.kanewski@gmail.com', 'mehzabeen.choudhari@sourcework.in', 'tirthpatel5885@gmail.com', 'vivokbhoi00@gmail.com']

export const ONBOARDING_PATH = '/onboarding'

export const needsOnboarding = (user: any): boolean =>
    !!user &&
    !SUPERADMIN_EMAILS.includes(user.email) &&
    !user.personalSpaces?.length &&
    !user.contributedSpaces?.length &&
    !user.roles?.length
